import React from "react";
import { SingleForm } from "../../../../../change/forms/singleFormModel/SingleForm_view";
import { CreateOrganisationModel } from "./CreateOrganisation_model";
import { useCurrentOrganisationId } from "../../../../../../services/local/organisationContext/OrganisationContextModel";

const CreateOrganisationView: React.FC = () => {
  const organisationId = useCurrentOrganisationId();
  const [model] = React.useState(() => new CreateOrganisationModel(organisationId));
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <SingleForm model={model.formModel} />
        </div>
      </div>
    </div>
  );
};

export default CreateOrganisationView;
